export class UserAdsError extends Error {}
